import * as React from 'react'

function IconError(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={164}
      height={164}
      viewBox="0 0 164 164"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M163.92 81.81C163.92 36.628 127.292 0 82.11 0S.3 36.628.3 81.81s36.628 81.81 81.81 81.81 81.81-36.628 81.81-81.81z"
        fill="#F4BA27"
      />
      <path
        d="M129.92 102.03a9.71 9.71 0 01-9.53 9.49 7.117 7.117 0 01-.8 0 6.19 6.19 0 00-5.92 3.15c-7 12.71-20.34 19-33.44 18.76-13.23-.63-26.24-7.89-32.35-21.29a5.361 5.361 0 00-5.12-3.13h-.51a9.692 9.692 0 01-9.6-9.35 9.63 9.63 0 019.93-9.89 1.87 1.87 0 002-1.68C47.27 60.6 65.36 47.16 83 47.6c17.61.7 34.78 15.26 35.71 42.83a1.933 1.933 0 001.88 1.86 9.63 9.63 0 019.33 9.74z"
        fill="#fff"
      />
      <path
        d="M116.99 100.55a.706.706 0 01-.52-.26.7.7 0 01-.161-.524.679.679 0 01.271-.476c.16-.13 3.93-3 10.07-1.41a.687.687 0 01.415.32.673.673 0 01.065.52.692.692 0 01-.84.49c-5.44-1.45-8.72 1-8.86 1.15a.672.672 0 01-.44.19z"
        fill="#000"
      />
      <path
        d="M125.28 102.62a.672.672 0 01-.55-.32 6.941 6.941 0 00-4.68-3.15.683.683 0 01-.586-.484.665.665 0 01-.024-.266.677.677 0 01.484-.586.68.68 0 01.266-.024 8.267 8.267 0 015.69 3.77.698.698 0 01.116.546.678.678 0 01-.326.454.68.68 0 01-.39.06zM46.59 98.28a.72.72 0 01-.43-.18c-.14-.12-3.24-2.82-8.77-1.73a.67.67 0 01-.8-.54.67.67 0 01.53-.8c6.24-1.24 9.81 1.92 10 2a.669.669 0 010 1 .68.68 0 01-.53.25z"
        fill="#000"
      />
      <path
        d="M38.18 99.8a.67.67 0 01-.38-.13.69.69 0 01-.15-1 8.34 8.34 0 015.93-3.4.69.69 0 01.529 1.153.683.683 0 01-.48.217 6.919 6.919 0 00-4.869 2.84.68.68 0 01-.58.32zM82.25 106.45a.687.687 0 01-.407-1.216.669.669 0 01.237-.124c5.4-1.64 5.78-2.54 5.79-2.71.05-.37-1.28-1.15-2.07-1.62a9.135 9.135 0 01-3.26-2.63c-1.95-3.28-.63-15.35-.47-16.72a.69.69 0 011.222-.348.67.67 0 01.138.508c-.41 3.58-1.16 13.42.29 15.85a8.401 8.401 0 002.78 2.16c1.48.88 2.89 1.71 2.74 3-.15 1.29-1.34 2.2-6.77 3.85a.81.81 0 01-.22 0zM103.452 95.495c.088-2.722-1.093-4.968-2.639-5.018-1.545-.05-2.87 2.115-2.958 4.837-.088 2.721 1.094 4.968 2.64 5.017 1.545.05 2.87-2.115 2.957-4.837zM67.613 94.176c.091-2.81-1.129-5.13-2.724-5.18-1.595-.052-2.962 2.183-3.053 4.993-.09 2.81 1.13 5.13 2.724 5.18 1.596.052 2.962-2.184 3.053-4.993z"
        fill="#000"
      />
      <path
        d="M42.56 89.75S23.1 86.92 26.83 70c3.73-16.92 9.84-14.86 13.92-25.21 4.08-10.35 21-18.81 39.33-11.47 18.33 7.34 31.6-6.85 43.86-2.14 12.26 4.71 2.16 14.49 4.1 18.86 1.94 4.37 9.9 7.06 7.33 17.09-2.57 10.03-8.09 27.22-15.72 24.87-6.43-2-5.43-27.22-15.95-31.12-9.65-3.58-24.09 10.48-41.78 4a3.91 3.91 0 00-5.23 3.28c-.86 8.03-3.84 21.9-14.13 21.59z"
        fill="#E84E25"
      />
      <path
        d="M57.68 82.37a.69.69 0 01-.57-1.04c0-.08 5.14-8.43 14.25-5.86a.7.7 0 01.47.85.69.69 0 01-.85.47c-8.1-2.29-12.64 5.16-12.69 5.24a.71.71 0 01-.61.34zM108.55 83.67a.697.697 0 01-.59-.38c-.17-.32-4.12-7.81-12.33-6a.69.69 0 01-.718-1.043.68.68 0 01.428-.297c9.25-2 13.79 6.67 13.84 6.76a.68.68 0 01-.3.92.67.67 0 01-.33.04z"
        fill="#000"
      />
      <path
        d="M64.414 110.063c5.18-.904 9.083-3.33 8.718-5.419-.364-2.089-4.859-3.05-10.038-2.146-5.18.904-9.083 3.33-8.718 5.419.364 2.09 4.859 3.05 10.038 2.146zM109.793 110.013c.581-2.039-3.047-4.861-8.103-6.301-5.057-1.44-9.627-.955-10.208 1.085-.581 2.04 3.047 4.861 8.104 6.301 5.056 1.44 9.626.955 10.207-1.085z"
        fill="#FFDEDE"
      />
      <path
        d="M79.5 118.96a5.1 5.1 0 01-3.617-1.5 5.114 5.114 0 01-1.493-3.62 5.11 5.11 0 015.11-5.11 5.12 5.12 0 013.62 1.493 5.12 5.12 0 011.5 3.617 5.118 5.118 0 01-5.12 5.12zm0-8.93a3.822 3.822 0 00-3.81 3.81 3.821 3.821 0 003.81 3.82 3.818 3.818 0 003.82-3.82 3.823 3.823 0 00-3.82-3.81z"
        fill="#000"
      />
    </svg>
  )
}

export default IconError
